module.exports = __webpack_public_path__ + "doctor-green.png?33680dd180469123ccfaf233121371ab";


//////////////////
// WEBPACK FOOTER
// ./images/doctor-green.png
// module id = 168
// module chunks = 0